import {Route, Routes} from 'react-router-dom'
import {ForgotPassword} from './components/ForgotPassword'
import {Totp} from './components/Totp'
import {Login} from './components/Login'
import {EmailLogin} from './components/EmailLogin'
import {AuthLayout} from './AuthLayout'
import {LostPasswordUpdate} from './components/LostPasswordUpdate'
import {DashboardAuth} from './components/DashboardAuth'
import {EmailAuth} from './components/EmailAuth'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='totp' element={<Totp />} />
      <Route path='forgot-password/:pagetype' element={<ForgotPassword />} />
      <Route path='loginemail' element={<EmailLogin />} />
      <Route path='lostpasswordupdate/:lostpasswordguid' element={<LostPasswordUpdate />} />
      <Route path='register/:registerguid' element={<LostPasswordUpdate />} />
      <Route path='reset/:resetguid' element={<LostPasswordUpdate />} />
      <Route path='dashboardauth' element={<DashboardAuth />} />
      <Route path='emailauth' element={<EmailAuth />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
